module.exports = __webpack_public_path__ + "img/page.aafd19b1.png";